import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=7f0f059b&scoped=true"
import script from "./finish.vue?vue&type=script&lang=ts"
export * from "./finish.vue?vue&type=script&lang=ts"
import style0 from "./finish.vue?vue&type=style&index=0&id=7f0f059b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f059b",
  null
  
)

export default component.exports